import { MapPin, Phone, Clock, Navigation } from 'lucide-react';
import { RESTAURANT } from '../constants/restaurant';

export const LocationSection = () => {
  return (
    <section
      id="contact"
      data-testid="location-section"
      className="bg-brand-coffee text-brand-cream py-24 md:py-32 px-6 md:px-12 lg:px-16 relative overflow-hidden"
    >
      <div className="absolute inset-0 grain-overlay opacity-30" />
      <div className="max-w-7xl mx-auto relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-stretch">
          {/* Info */}
          <div className="lg:col-span-5 flex flex-col justify-between">
            <div>
              <p className="text-xs uppercase tracking-[0.3em] font-semibold text-brand-gold mb-5">
                Find Us
              </p>
              <h2
                data-testid="location-heading"
                className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
              >
                Come, share a table with us.
              </h2>
              <p className="mt-6 text-brand-cream/75 text-base md:text-lg max-w-md leading-relaxed">
                Tucked along Kingsford Smith Parade, Maroochydore — a short stroll from the
                river. Walk-ins welcome; bookings recommended.
              </p>
            </div>

            <ul className="mt-10 space-y-6">
              <li className="flex items-start gap-4">
                <span className="w-11 h-11 rounded-full bg-brand-cream/10 border border-brand-cream/20 flex items-center justify-center shrink-0">
                  <MapPin className="w-5 h-5 text-brand-gold" />
                </span>
                <div>
                  <p className="text-[11px] uppercase tracking-[0.25em] text-brand-cream/55 font-semibold">
                    Address
                  </p>
                  <p
                    data-testid="contact-address"
                    className="font-serif text-xl text-brand-cream mt-1"
                  >
                    {RESTAURANT.address}
                  </p>
                  <a
                    href={RESTAURANT.mapsDirections}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="contact-directions"
                    className="inline-flex items-center gap-2 text-sm text-brand-gold mt-2 hover:underline"
                  >
                    <Navigation className="w-3.5 h-3.5" />
                    Get Directions
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <span className="w-11 h-11 rounded-full bg-brand-cream/10 border border-brand-cream/20 flex items-center justify-center shrink-0">
                  <Phone className="w-5 h-5 text-brand-gold" />
                </span>
                <div>
                  <p className="text-[11px] uppercase tracking-[0.25em] text-brand-cream/55 font-semibold">
                    Phone
                  </p>
                  <a
                    href={`tel:${RESTAURANT.phoneRaw}`}
                    data-testid="contact-phone"
                    className="font-serif text-xl text-brand-cream mt-1 hover:text-brand-gold transition"
                  >
                    {RESTAURANT.phone}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <span className="w-11 h-11 rounded-full bg-brand-cream/10 border border-brand-cream/20 flex items-center justify-center shrink-0">
                  <Clock className="w-5 h-5 text-brand-gold" />
                </span>
                <div>
                  <p className="text-[11px] uppercase tracking-[0.25em] text-brand-cream/55 font-semibold">
                    Hours
                  </p>
                  <p className="font-serif text-xl text-brand-cream mt-1">
                    Open 7 days · Lunch &amp; Dinner
                  </p>
                </div>
              </li>
            </ul>
          </div>

          {/* Map */}
          <div className="lg:col-span-7">
            <div className="relative rounded-3xl overflow-hidden border border-brand-cream/15 h-[420px] md:h-[560px] shadow-[0_40px_80px_rgba(0,0,0,0.35)]">
              <iframe
                title="Sankalp Restaurant Sunshine Coast location"
                src={RESTAURANT.mapsEmbed}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="contact-map"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
